import { useFragment } from '@apollo/client/react';
import { DocumentMetadataPropertyReferenceEnum } from 'shared/domains/apollo/generated/types';
import { AddMetadataReferenceFileSelection } from './AddMetadataReferenceFileSelection';
import { AddMetadataReferenceUserSelection } from './AddMetadataReferenceUserSelection';
import { AddMetadataSelectSelectionFragmentDoc, } from './AddMetadataSelectSelection.gql';
import { ListSelection } from './ListSelection';
export function AddMetadataSelectSelection(props) {
    const { from } = props;
    const { data, complete } = useFragment({
        from,
        fragment: AddMetadataSelectSelectionFragmentDoc,
    });
    if (!complete) {
        return null;
    }
    const { isMultiSelect, allowedValues, label } = data || {};
    const allowedValueItems = (allowedValues === null || allowedValues === void 0 ? void 0 : allowedValues.map((aw) => (Object.assign({ id: aw.value }, aw)))) || [];
    if (allowedValueItems.length) {
        return <ListSelection label={label} items={allowedValueItems} isMultiSelect={isMultiSelect}/>;
    }
    if ((data === null || data === void 0 ? void 0 : data.reference) === DocumentMetadataPropertyReferenceEnum.User) {
        return <AddMetadataReferenceUserSelection isMultiSelect={isMultiSelect} label={label}/>;
    }
    return <AddMetadataReferenceFileSelection isMultiSelect={isMultiSelect} label={label}/>;
}
